import ReducerUtils         from "../../../utils/ReducerUtils"
import Actions              from "../../../model/constant/actions"

const editingAudienceAds = ReducerUtils.createReducer(false,{
  [Actions.EDITING_AUDIENCEADS] : (state,action) => action.status
})

export default editingAudienceAds
